import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
    addData,
    deleteData,
    getAllData,
    getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import Switch from "@mui/material/Switch";
import moment from "moment/moment";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
const CreateCampaign = (props) => {
    const { onClose, editData, open, ...other } = props;
    const [isLoading, setIsLoading] = useState(false);

    const [campaignName, setCampaignName] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [maxCredit, setMaxCredit] = useState("");
    const [maxNumber, setMaxNumber] = useState("");
    const [bonusExpiry, setBonusExpiry] = useState("");
    const [bonusExpiryDay, setBonusExpiryDay] = useState("");
    const [promoCode, setPromoCode] = useState("");


    const params = useParams();



    React.useEffect(() => {
        if (open) {
            if (Object.keys(editData).length === 0) {
                setCampaignName(editData?.campaignName);
                setMaxCredit(editData?.maxCredit);
                setMaxNumber(editData?.maxNumber);
                setPromoCode(editData?.promoCode);
                // setStartdate("");
                setBonusExpiry("");
                setStartTime("");
                setEndTime("");
            } else {
                setCampaignName(editData?.campaignName);
                setMaxCredit(editData?.maxCredit || "");
                setMaxNumber(editData?.maxNumber || "");
                setBonusExpiry(moment(editData?.bonusExpiry).format("YYYY-MM-DD"));
                setPromoCode(editData?.promoCode || "");
                setStartTime(moment(editData?.startTime).format("YYYY-MM-DD"));
                // setStartTime(moment.utc(editData?.startTime).format("HH:mm"));
                setEndTime(moment(editData?.endTime).format("YYYY-MM-DD"));
                // setEndTime(moment.utc(editData?.endTime).format("HH:mm"));
            }
        }
    }, [editData, open]);

    const handleCancel = () => {
        onClose();
    };






    const handleOk = () => {
        if (campaignName && startTime && endTime && maxCredit && maxNumber && bonusExpiry && promoCode) {
            let url = editData?.idCampaign
                ? `${endPoints.api.UPDATE_CAMPAIGN}`
                : `${endPoints.api.CREATE_CAMPAIGN}`;

            let payload = {
                campaignName: campaignName,
                startTime: startTime,
                endTime: endTime,
                maxCredit: maxCredit,
                maxNumber: maxNumber,
                bonusExpiry: bonusExpiry,
                promoCode: promoCode,
                bonusExpiryDay:bonusExpiryDay
            };

            if (editData?.idCampaign) {
                payload.idCampaign = editData.idCampaign;
            }
            setIsLoading(true);
            addData(url, payload)
                .then((response) => {
                    setIsLoading(false);
                    if (response.data.status === "success") {
                        SuccesToast(response?.data?.message);
                        onClose();
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error(error);
                    ErrorToast(error);
                });
        } else {
            ErrorToast("all fields are required");
        }
    };

    return (
        <Dialog
            xl={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 435 } }}
            maxWidth="sm"
            open={open}
            {...other}
        >
            <DialogTitle>Campaign Info </DialogTitle>

            <DialogContent dividers>
                <Toaster></Toaster>
                {isLoading && <Loader spinner={true} visible={isLoading} />}

                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        label="Campaign Name"
                        value={campaignName}
                        onChange={(event) => {
                            setCampaignName(event.target.value);
                        }}
                    />
                </FormControl>

                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <label>Start Date</label>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        placeholder="start date"
                        type="date"
                        value={startTime}
                        onChange={(event) => {
                            setStartTime(event.target.value);
                        }}
                    />
                </FormControl>

                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <label>End Date</label>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        type="date"
                        value={endTime}
                        onChange={(event) => {
                            setEndTime(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        label="Max Bonus amount per credit"
                        type="number"
                        value={maxCredit}
                        onChange={(event) => {
                            setMaxCredit(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        label="Max Number of credits per customer"
                        value={maxNumber}
                        onChange={(event) => {
                            setMaxNumber(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <label>Bonus Expiry date </label>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        type="date"
                        value={bonusExpiry}
                        onChange={(event) => {
                            setBonusExpiry(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <label>Bonus Expiry Days </label>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                      
                        value={bonusExpiryDay}
                        onChange={(event) => {
                            setBonusExpiryDay(event.target.value);
                        }}
                    />
                </FormControl>

                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="filled-required"
                        variant="outlined"
                        label="Promocode"
                        value={promoCode}
                        onChange={(event) => {
                            setPromoCode(event.target.value);
                        }}
                    />
                </FormControl>


            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateCampaign;
